module.exports = __webpack_public_path__ + "img/date-range-24-px.36442146.svg";